import { ColorFieldDef } from "./schema";

export const resolveColor = (
  fields: ColorFieldDef[],
  overrides: Record<string, string>,
  key: string,
  seen: Set<string> = new Set()
): string => {
  const field = fields.find((f) => f.key === key);
  if (!field) return "#000000";
  if (seen.has(key)) return "#000000";
  seen.add(key);

  const overrideValue = !field.derivedFrom ? overrides[key] : undefined;
  if (overrideValue) return overrideValue;

  if (field.fallback.type === "literal") return field.fallback.value;
  return resolveColor(fields, overrides, field.fallback.key, seen);
};

export const isOverridden = (
  fields: ColorFieldDef[],
  overrides: Record<string, string>,
  key: string
): boolean => {
  const field = fields.find((f) => f.key === key);
  if (!field || field.derivedFrom) return false;
  return Boolean(overrides[key]);
};

export const fallbackLabel = (
  fields: ColorFieldDef[],
  key: string
): string => {
  const field = fields.find((f) => f.key === key);
  if (!field) return "";
  const fallback = field.fallback;
  if (fallback.type === "literal") return fallback.value;
  const target = fields.find((f) => f.key === fallback.key);
  return target?.label ?? fallback.key;
};

export type ResolvedColors = Record<string, string>;

export const resolveAll = (
  fields: ColorFieldDef[],
  overrides: Record<string, string>
): ResolvedColors => {
  const result: ResolvedColors = {};
  for (const field of fields) {
    result[field.key] = resolveColor(fields, overrides, field.key);
  }
  return result;
};
